import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.form = this.el;
        this.data = JSON.parse(this.form.dataset.data);
        this.salle = this.form.querySelector('#Salle');
        this.forfait = this.form.querySelector('#Forfait');
        this.typeEvenement = this.form.querySelector('#type-evenement');
        this.configuration = this.form.querySelector('#configuration');
        this.prive = this.form.querySelector('#entreprise-prive');
        this.organisme = this.form.querySelector('#organisme');
        this.cocktailToggle = this.form.querySelector('.js-cocktail-toggle');
        this.cocktail = this.form.querySelector('.js-cocktail-field');

        // remove every options exept the first one for typeEvenement and configuration
        this.typeEvenement.querySelectorAll('option').forEach((option, index) => {
            if (index !== 0) {
                option.remove();
            }
        });
        this.configuration.querySelectorAll('option').forEach((option, index) => {
            if (index !== 0) {
                option.remove();
            }
        });

        this.data.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.evenement;
            option.innerText = item.evenement;
            this.typeEvenement.appendChild(option);
        })

        this.typeEvenement.addEventListener('change', () => {
            this.updateSalle();
        });
        this.salle.addEventListener('change', () => {
            this.updateConfiguration();
        });
        this.configuration.addEventListener('change', () => {
            this.updateForfait();
        });
        this.prive.addEventListener('change', () => {
            this.updateConfiguration();
        });
        this.organisme.addEventListener('change', () => {
            this.updateConfiguration();
        });
        this.forfait.addEventListener('change', () => {
            this.updatePrix();
        });
        this.cocktailToggle.addEventListener('change', () => {
            this.updateCocktail();
        });
    }

    updateSalle() {
        const evenement = this.typeEvenement.value;

        if (!evenement) {
            return;
        }

        // remove every options exept the first one for salle
        this.salle.querySelectorAll('option').forEach((option, index) => {
            if (index !== 0) {
                option.remove();
            }
        });

        let salles = [];
        this.data.forEach((item) => {
            if (item.evenement === evenement) {
                item.configurations.forEach((configuration) => {
                    if (salles.indexOf(configuration.salle) !== -1) {
                        return;
                    }
                    salles.push(configuration.salle);
                    const option = document.createElement('option');
                    option.value = configuration.salle;
                    option.innerText = configuration.salle;
                    this.salle.appendChild(option);
                });
            }
        });

        // if salle has only one option, select it
        if (this.salle.querySelectorAll('option').length === 2) {
            this.salle.querySelector('option:nth-child(2)').selected = true;
        }
        this.updateConfiguration();
    }

    updateCocktail() {
        if (this.cocktailToggle.checked) {
            this.cocktail.classList.remove('hidden');
        } else {
            this.cocktail.classList.add('hidden');
        }
    }

    updateConfiguration() {
        const evenement = this.typeEvenement.value;
        const salle = this.salle.value;
        const prive = this.prive.checked;

        if (!evenement || !salle) {
            return;
        }

        // remove every options exept the first one for configuration
        this.configuration.querySelectorAll('option').forEach((option, index) => {
            if (index !== 0) {
                option.remove();
            }
        });

        let configurations = [];
        this.data.forEach((item) => {
            if (item.evenement === evenement) {
                item.configurations.forEach((configuration) => {
                    const entreprise = prive ? 'prive' : 'obnl';
                    if (configuration.salle === salle && entreprise == configuration.type_dentreprise) {
                        if (configurations.indexOf(configuration.configuration) !== -1) {
                            return;
                        }
                        configurations.push(configuration.configuration);
                        const option = document.createElement('option');
                        option.value = configuration.configuration;
                        option.innerText = configuration.configuration;
                        this.configuration.appendChild(option);
                    }
                });
            }
        });

        // if configuration has only one option, select it
        if (this.configuration.querySelectorAll('option').length === 2) {
            this.configuration.querySelector('option:nth-child(2)').selected = true;
        }
        this.updateForfait();
    }

    updateForfait() {
        const evenement = this.typeEvenement.value;
        const salle = this.salle.value;
        const configuration = this.configuration.value;
        const prive = this.prive.checked;

        if (!evenement || !salle || !configuration) {
            return;
        }

        // remove every options exept the first one for forfait
        this.forfait.querySelectorAll('option').forEach((option, index) => {
            if (index !== 0) {
                option.remove();
            }
        });

        let forfaits = [];
        this.data.forEach((item) => {
            if (item.evenement === evenement) {
                item.configurations.forEach((config) => {
                    const entreprise = prive ? 'prive' : 'obnl';
                    if (config.salle === salle && config.configuration === configuration && entreprise == config.type_dentreprise) {
                        if (forfaits.indexOf(config.forfait) !== -1) {
                            return;
                        }
                        forfaits.push(config.forfait);
                        const option = document.createElement('option');
                        option.value = config.forfait;
                        option.innerText = config.forfait + ' - ' + config.prix + ' $';
                        this.forfait.appendChild(option);
                    }
                });
            }
        });

        // if forfait has only one option, select it
        if (this.forfait.querySelectorAll('option').length === 2) {
            this.forfait.querySelector('option:nth-child(2)').selected = true;
            this.updatePrix();
        } else {
            // reset prix
            this.form.querySelector('#forfaitLabel').innerText = '';
            this.form.querySelector('#forfaitPrix').innerText = '';
            this.form.querySelector('#forfait').value = '';
        }
        this.updatePrix();
    }

    updatePrix() {
        const evenement = this.typeEvenement.value;
        const salle = this.salle.value;
        const configuration = this.configuration.value;
        const prive = this.prive.checked;
        const forfait = this.forfait.value;

        if (!evenement || !salle || !configuration || !forfait) {
            return;
        }

        this.data.forEach((item) => {
            if (item.evenement === evenement) {
                item.configurations.forEach((config) => {
                    const entreprise = prive ? 'prive' : 'obnl';
                    if (config.salle === salle && config.configuration === configuration && entreprise == config.type_dentreprise && config.forfait === forfait) {
                        // format prix
                        const prix = config.prix.toString();
                        const prixFormat = prix.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

                        this.form.querySelector('#forfaitLabel').innerText = config.forfait;
                        this.form.querySelector('#forfaitPrix').innerText = prixFormat + ' $';
                        this.form.querySelector('#forfait').value = config.forfait + ' - ' + prixFormat + ' $';
                    }
                });
            }
        });
    }
}
